export default () => {
  const search_config: any = {
    model: {},
    watch: ['name1', 'name2'],
  };
  return {
    getData: () => {
      console.log('fetch data');

      return new Promise(resolve => {
        resolve(1000000);
      });
    },
    searchConfig: search_config,
  };
};
